import { Link } from 'react-router-dom';
import { HelpCircle, ChevronDown } from 'lucide-react';
import { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const NAV_ITEMS = [
  { to: '/', label: 'Home' },
  { to: '/gallery', label: 'Gallery' },
  { to: '/archive', label: 'Archive' },
];

const FOOTER_LEGAL_LINKS = [
  { to: '/privacy', label: 'Privacy' },
  { to: '/terms', label: 'Terms' },
  { to: '/shipping', label: 'Shipping' },
  { to: '/faq', label: 'FAQ' },
];

function FAQ() {
  // Placeholder FAQ items - replace with your own content
  const [faqs] = useState([
    {
      question: "How long does shipping take?",
      answer: "Most orders ship within 1-3 business days from Edenton, NC. Standard delivery typically takes 3-7 business days within the continental US. Fine art prints are made to order and may take 5-7 business days to process."
    },
    {
      question: "What is your return policy?",
      answer: "We want you to be happy! If within 30 days you want to return an item for any reason, we will gladly exchange or credit any item returned in new and unused condition. See our Terms page for full details."
    },
    {
      question: "Do you ship internationally?",
      answer: "Currently, we only ship within the United States including P.O. Boxes and APO addresses. We're working on expanding our shipping options in the future."
    },
    {
      question: "How do I track my order?",
      answer: "Once your order ships, you'll receive an email with tracking information. All orders are shipped via USPS."
    },
    {
      question: "What payment methods do you accept?",
      answer: "We accept all major credit cards through our secure Stripe payment processing. Your payment information is never stored on our servers."
    },
    {
      question: "How do I cancel my newsletter subscription?",
      answer: "You can unsubscribe at any time by clicking the unsubscribe link at the bottom of any newsletter email. For paid subscriptions, contact us at support@theobxbeachbum.com."
    }
  ]);

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="substack-site">
      <Header navItems={NAV_ITEMS} />

      <main className="faq-page">
        <div className="faq-container">
          <div className="faq-header">
            <HelpCircle size={48} />
            <h1>Frequently Asked Questions</h1>
            <p>Got questions? We've got answers.</p>
          </div>

          <div className="faq-list">
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                className={`faq-item ${openIndex === index ? 'open' : ''}`}
              >
                <button 
                  className="faq-question"
                  onClick={() => toggleFaq(index)}
                >
                  <span>{faq.question}</span>
                  <ChevronDown 
                    size={20} 
                    className={`faq-icon ${openIndex === index ? 'rotated' : ''}`}
                  />
                </button>
                {openIndex === index && (
                  <div className="faq-answer">
                    <p>{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="faq-contact">
            <h2>Still have questions?</h2>
            <p>
              Can't find what you're looking for? Feel free to reach out to us at{' '}
              <a href="mailto:support@theobxbeachbum.com">support@theobxbeachbum.com</a>{' '}
              or call <strong>1-252-378-8844</strong>.
            </p>
          </div>

          <div className="back-link">
            <Link to="/">← Back to Home</Link>
          </div>
        </div>
      </main>

      <Footer showLogo={false} legalLinks={FOOTER_LEGAL_LINKS} />
    </div>
  );
}

export default FAQ;
